import { CREATE_LINKEDIN_POST_SUCCESS } from '../constants/actionTypes';

const INITIAL_STATE = { posts: {}, errors: null };

export default function linkedInPosts(state=INITIAL_STATE, action) {
  
  switch(action.type) {
    case CREATE_LINKEDIN_POST_SUCCESS:
      
      
      return { ...state, posts: action.payload.data, errors: null }
    default:
      return state;
  }
}